// 공통 상수 — FEAT-002 ADR-003 결정 3 (상태 enum 공통 추출)
//
// features.yaml 의 components.status 는 본 enum 만 허용.
// 운영 상태 (Backlog / 개발중 / SQA / RC / 출시 / 보류) 와 데이터 파일
// 상태값 (planned / wip / qa / rc / done / blocked) 의 단일 출처.
//
// 사용처:
//   - components/feature-map/ComponentRow.jsx (편집 시 선택 옵션)
//   - components/matrix/MatrixCell.jsx (매트릭스 셀 표시)
//   - 그 외 status 의존 컴포넌트

export const COMPONENT_STATUSES = ['planned', 'wip', 'qa', 'rc', 'done', 'blocked'];

// 한글 라벨 — 사용자 화면에 노출. (영문 코드는 데이터 파일에만)
export const COMPONENT_STATUS_LABEL = {
  planned: 'Backlog',
  wip: '개발중',
  qa: 'SQA',
  rc: 'RC',
  done: '출시',
  blocked: '보류',
};

// MUI Chip color — 매트릭스 셀 / 행 표시 색상 매핑
export const COMPONENT_STATUS_COLOR = {
  planned: 'default',
  wip: 'warning',
  qa: 'info',
  rc: 'secondary',
  done: 'success',
  blocked: 'error',
};

// 짧은 설명 — 마우스오버 tooltip 등에서 사용
export const COMPONENT_STATUS_DESC = {
  planned: '계획됨 — 아직 시작 안 함',
  wip: '진행 중 — 개발 진행 중',
  qa: '품질 검증 — SQA 단계',
  rc: '출시 후보 — Release Candidate',
  done: '출시됨 — 릴리즈 완료',
  blocked: '보류됨 — 외부 의존 또는 차단',
};

// 알 수 없는 상태값 fallback (EC-03)
export const UNKNOWN_STATUS_LABEL = '미확인';
export const UNKNOWN_STATUS_COLOR = 'default';

// 빈 매핑 도움말 — 결정 6 (2026-05-13)
export const EMPTY_MAPPING_TOOLTIP =
  '아직 매핑 데이터가 입력되지 않았습니다. 매핑은 데이터 파일을 직접 편집하거나 Phase 3 입력 도구 (출시 예정) 로 보강 가능.';

// FEAT-004 Phase 4 — Project lifecycle status 4단계 (사용자 결정 2026-05-13)
// Plan → WIP → Done → Archive
export const PROJECT_STATUSES = ['plan', 'wip', 'done', 'archive'];

export const PROJECT_STATUS_LABEL = {
  plan: 'Plan',
  wip: 'WIP',
  done: 'Done',
  archive: 'Archive',
};

export const PROJECT_STATUS_COLOR = {
  plan: 'default',
  wip: 'warning',
  done: 'success',
  archive: 'info',
};

export const PROJECT_STATUS_DESC = {
  plan: '계획 단계 — 아직 시작 안 함',
  wip: '진행 중 (Work In Progress)',
  done: '완료 — release 완료, 운영 중',
  archive: '종료 / EoL / 보류 — 참고용 보관',
};

export const UNKNOWN_PROJECT_STATUS_LABEL = '미확인';
export const UNKNOWN_PROJECT_STATUS_COLOR = 'default';
